// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3ME4O","Dark":"Logo_Dark__RAdpl","Light":"Logo_Light__3b-rI","Stories":"Logo_Stories__3rnGC"};